
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"url(#paint0_linear_10245_8007)","d":"M1.354.646l24 24"}}),_c('path',{attrs:{"stroke":"url(#paint1_linear_10245_8007)","d":"M.646 24.646l24-24"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_10245_8007","x1":"1.5","y1":".5","x2":"25.474","y2":"25.07","gradientUnits":"userSpaceOnUse"}},[_c('stop'),_c('stop',{attrs:{"offset":".703","stop-color":"#E27CFC"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_10245_8007","x1":"1.023","y1":"24.477","x2":"18.477","y2":"7.023","gradientUnits":"userSpaceOnUse"}},[_c('stop'),_c('stop',{attrs:{"offset":"1","stop-color":"#E27CFC"}})])])])
          )
        }
      }
    